/**
 * Display-only label maps for API enum/status values shown in the
 * Bookings / Coupons / Invoicing / Accounting screens. Values sent to or
 * received from the API are never changed — these maps only affect what
 * the admin sees. Always fall back to the raw value for anything missing.
 */

// Booking `description` (service code) -> Bulgarian display name.
// Mirrors my-pet-app/public/locales/bg/services.json + groomerServices.json,
// the canonical source for these codes.
export const SERVICE_LABELS = {
  daily_shift: "Преглед (08-19 ч)",
  night_shift: "Преглед (20–08 ч)",
  check_up: "Преглед при специалист",
  follow_up: "Контр. преглед",
  examination_specialist: "Преглед специалист",
  "follow-up_examination_specialis": "Преглед при специалист – контролен",
  home_visit: "Депозит за дом. посещение",
  issuance_re_issuance_issuance_international_passport: "Издаване/преиздаване международен паспорт",
  "issuance_re-issuance_issuance_international_passport": "Издаване/преиздаване международен паспорт",
  placing_microchip: "Поставяне на микрочип",
  annual_vaccine: "Годишна ваксина",
  kc_vaccine_intranasal: "Ваксина Kennel cough",
  eureka_vaccine: "Ваксина Eurikan Herpes 205",
  monovalent_rabies: "Моновалентна – бяс",
  deworming: "Обезпаразитяване",
  external_deworming_detergent_fipronil: "Външно обезпаразитяване",
  complex_dewormging: "Комплексно обезпаразитяване",
  removal_tick: "Отстраняване на кърлеж",
  subcutaneous_intramuscular_injection: "Инжекция",
  giving_medication_mouth: "Лекарство през уста",
  blood_sampling: "Вземане на кръв",
  blood_pressure_measurement: "Измерване на кръвно",
  bandage_splint: "Превръзка/шина",
  cleaning_anal_glands: "Почистване на анални жлези",
  nail_trimming: "Изрязване на нокти",
  teeth_cutting: "Изрязване на зъби",
  extraction_deciduous_teeth: "Екстракция на млечен зъб",
  extraction_canine_teeth: "Екстракция на кучешки зъб",
  diagnosis_pregnancy: "Диагностика на бременност",
  pregnancy_monitoring: "Мониторинг на бременност",
  "in-patient_daily_care": "Болничен престой на ден",
  oxygen_hour: "Кислород на час",
  oxygen_12: "Кислород за 12 часа",
  venous_placement: "Венозен катетър",
  system_bank: "Поставяне на система-банка",
  anesthesia: "Анестезия",
  termination_pregnancy_without_medication: "Прекъсване на бременност",
  birth_delivery: "Раждане",
  castration_male_dog: "Кастрация на мъжко куче",
  castration_female_dog: "Кастрация на женско куче",
  castration_cryptorchid: "Кастрация на крипторхид",
  castration_male_cat: "Кастрация на мъжка котка",
  castration_female_cat: "Кастрация на женска котка",
  complete_blood_count: "Пълна кръвна картина",
  biopsies: "Биопсии",
  ecg: "ЕКГ",
  radiography: "Рентгенография",
  certificate_dysplasia: "Сертификат за тазобедрена дисплазия",
  radioscopy_tracheal: "Рентгеноскопия – трахеален колапс",
  radioscopy: "Рентгеноскопия – на 15 минути",
  portography: "Портография",
  echocardiography: "Ехокардиография",
  ultrasound: "Ехография - очи",
  angiography: "Ангиография",
  bronchography: "Бронхография",
  bronchography_bal: "Бронхиоалвеоларен лаваж (БАЛ)",
  contrast_angiography: "Ангиография с контраст",
  nuclear_magnetic_resonance: "ЯМР",
  ct: "Компютърна томография",
  euthanasia: "Евтаназия",
  autopsy: "Аутопсия",
  rendering: "Екарисаж",
  online_consultation: "Незабавна консултация",
  other: "Други услуги (депозит)",

  // Groomer services
  bath_1_4: "Къпане 1-4 kg",
  bath_5_35: "Къпане 5-35 kg",
  bath_35_55: "Къпане 35-55 kg",
  bath_55: "Къпане 55+ kg",
  full_hair_cut_1_4: "Пълно подстригване 1-4 kg",
  full_hair_cut_5_35: "Пълно подстригване 5-35 kg",
  full_hair_cut_35_55: "Пълно подстригване 35-55 kg",
  full_hair_cut_55: "Пълно подстригване 55+ kg",
  hair_trim_1_4: "Оформяне с подрязване 1-4 kg",
  hair_trim_5_35: "Оформяне с подрязване 5-35 kg",
  hair_trim_35_55: "Оформяне с подрязване 35-55 kg",
  hair_trim_55: "Оформяне с подрязване 55+ kg",
  nail_trim_1_4: "Подрязване на нокти 1-4 kg",
  nail_trim_5_35: "Подрязване на нокти 5-35 kg",
  nail_trim_35_55: "Подрязване на нокти 35-55 kg",
  nail_trim_55: "Подрязване на нокти 55+ kg",
  ear_clean_1_4: "Почистване на уши 1-4 kg",
  ear_clean_5_35: "Почистване на уши 5-35 kg",
  ear_clean_35_55: "Почистване на уши 35-55 kg",
  ear_clean_55: "Почистване на уши 55+ kg",
  brushing_1_4: "Разресване 1-4 kg",
  brushing_5_35: "Разресване 5-35 kg",
  brushing_35_55: "Разресване 35-55 kg",
  brushing_55: "Разресване 55+ kg",
  deworming_1_4: "Обезпаразитяване 1-4 kg",
  deworming_5_35: "Обезпаразитяване 5-35 kg",
  deworming_35_55: "Обезпаразитяване 35-55 kg",
  deworming_55: "Обезпаразитяване 55+ kg",
  full_grooming_1_4: "Пълен груминг 1-4 kg",
  full_grooming_5_35: "Пълен груминг 5-35 kg",
  full_grooming_35_55: "Пълен груминг 35-55 kg",
  full_grooming_55: "Пълен груминг 55+ kg",
};

/** Booking `paymentStatus` -> Bulgarian display label. */
export const PAYMENT_STATUS_LABELS = {
  succeeded: "Успешно",
  not_required: "Не се изисква",
  pending: "Изчакващо",
  canceled: "Отказано",
  requires_payment_method: "Изисква начин на плащане",
  PAID: "Платено",
  voucher_success: "Платено с ваучер",
};

/** Booking `status` values (see the API's bookingModel enum). */
export const BOOKING_STATUS_LABELS = {
  SCHEDULED: "Насрочена",
  CANCELED: "Отказана",
  DONE: "Приключена",
  PAYMENT: "Чака плащане",
  WAITING: "Чака потвърждение",
  CONFIRMED: "Потвърдена",
  REJECTED: "Отхвърлена",
};

/** Booking `meetingType` values. */
export const MEETING_TYPE_LABELS = {
  OFFICE: "На място",
  ONLINE: "Онлайн",
  MANUAL: "Ръчно въведена",
  SUBSCRIPTION: "Абонамент",
};

/** Invoicing `bookingState` values (see the API's transactionAndInvoices model). */
export const BOOKING_STATE_LABELS = {
  prepaid: "Предплатена",
  pending: "Изчакваща",
  due: "За плащане",
  completed: "Приключена",
  refunded: "Възстановена",
};

/** Receipt `receivedType` -> Bulgarian display label. */
export const RECEIVED_TYPE_LABELS = {
  payment: "Плащане",
  refund: "Възстановяване",
};

/** Coupon professional-category option -> Bulgarian display label (value stays the raw option, uppercased, for the API). */
export const PROFESSIONAL_CATEGORY_LABELS = {
  Groomer: "Грумър",
  Vet: "Ветеринарен лекар",
  Clinic: "Ветеринарна клиника",
  Hotels: "Хотели",
};

/** User roles as the API sends them (see helpers/userRols.js). */
export const ROLE_LABELS = {
  PARENT: "Стопанин",
  VET: "Ветеринарен лекар",
  CLINIC: "Ветеринарна клиника",
  GROOMER: "Грумър",
  HOTELS: "Хотел",
  PET_SITTER: "Гледач",
  PET_WALKER: "Разхождач на кучета",
  SHELTER: "Приют",
  ADMIN: "Администратор",
  "SUPER-ADMIN": "Главен администратор",
  ACCOUNTING: "Счетоводител",
  "ACCOUNTING-VET": "Счетоводител (ветеринарен)",
};

/** Display label for a user role; falls back to the raw value. */
export const roleLabel = (role) => ROLE_LABELS[role] || role || "";

/** Combined lookup for the legacy tag-filter Search modal, which shows raw API values as buttons. */
export const TAG_VALUE_LABELS = {
  ...SERVICE_LABELS,
  ...PAYMENT_STATUS_LABELS,
  ...BOOKING_STATUS_LABELS,
  ...MEETING_TYPE_LABELS,
  ...ROLE_LABELS,
};

/** Headings for the tag groups the API returns to the legacy Search modal. */
export const TAG_GROUP_LABELS = {
  status: "Статус",
  paymentStatus: "Статус на плащане",
  "professionalID.role": "Вид специалист",
  meetingType: "Вид среща",
  description: "Услуга",
  actionModel: "Раздел",
};

/** Best-effort label for a raw API tag value; falls back to the value itself. */
export const tagLabel = (value) => TAG_VALUE_LABELS[value] || value;

/** Display label for a booking service code; falls back to the raw value. */
export const serviceLabel = (value) => SERVICE_LABELS[value] || value || "";

/** Display label for a booking payment status; falls back to the raw value. */
export const paymentStatusLabel = (value) => PAYMENT_STATUS_LABELS[value] || value || "";

/** The API's English language keys (e.g. 'english'); the keys are what gets saved. */
export const LANGUAGE_LABELS = {
  english: "Английски",
  bulgarian: "Български",
  german: "Немски",
  greek: "Гръцки",
  russian: "Руски",
  spanish: "Испански",
  italian: "Италиански",
  french: "Френски",
};

/** The API's English weekday keys ('monday'..'sunday'); the keys are what gets saved. */
export const WEEKDAY_LABELS = {
  monday: "Понеделник",
  tuesday: "Вторник",
  wednesday: "Сряда",
  thursday: "Четвъртък",
  friday: "Петък",
  saturday: "Събота",
  sunday: "Неделя",
};

export const weekdayLabel = (day) => WEEKDAY_LABELS[day] ?? day;

/** Display label for an invoicing `bookingState`; falls back to the raw value. */
export const bookingStateLabel = (value) => BOOKING_STATE_LABELS[value] || value || "";

/** Pet `type` values, as the app labels them. */
export const PET_TYPE_LABELS = {
  dog: "Куче",
  cat: "Котка",
  bird: "Птица",
  reptile: "Влечуго",
};

/** Pet `gender` values. */
export const PET_GENDER_LABELS = {
  male: "Мъжко",
  female: "Женско",
};

export const petTypeLabel = (value) => PET_TYPE_LABELS[value] || value || "";
export const petGenderLabel = (value) => PET_GENDER_LABELS[value] || value || "";
